import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseHttpService } from '../http/base.http.service';
import { ApiRouterService } from '../http/api.router';

@Injectable({
  providedIn: 'root',
})
export class SaeIntegrationsHttpService extends BaseHttpService {
  private baseURL = `sae-integrations`;
  private superAdminBaseURL = `superadmin/sae-integrations`;

  constructor(
    @Inject(HttpClient) httpClient: HttpClient,
    private routerService: ApiRouterService,
  ) {
    super(httpClient);
  }

  public getSaes() {
    let url = this.routerService.mount(`${this.baseURL}`);
    return this.read(url);
  }

  public searchSaeIntegrations(queryParams: Record<string, string>) {
    return this.list(this.routerService.mount(this.superAdminBaseURL), queryParams);
  }

  public getSaeIntegration(saeIntegrationId: number) {
    return this.read(this.routerService.mount(`${this.superAdminBaseURL}/${saeIntegrationId}`));
  }

  public createSaeIntegration(body: unknown) {
    return this.create(body, this.routerService.mount(this.superAdminBaseURL));
  }

  public updateSaeIntegration(saeIntegrationId: number, body: unknown) {
    return this.update(body, this.routerService.mount(`${this.superAdminBaseURL}/${saeIntegrationId}`));
  }

  public deleteSaeIntegration(saeIntegrationId: number) {
    return this.delete(this.routerService.mount(`${this.superAdminBaseURL}/${saeIntegrationId}`));
  }

}
